import { render, staticRenderFns } from "./IconCentre.vue?vue&type=template&id=7fe287f6&"
import script from "./IconCentre.vue?vue&type=script&lang=js&"
export * from "./IconCentre.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports